import controller from './oo-admin-modal-info.controller';
import template from './oo-admin-modal-info.html';

export default {
	bindings: {
		kid: '<',
	},
	controller,
	template,
	controllerAs: '$ctrl',
};
